module.exports = __webpack_public_path__ + "img/ipad-cn-13.942af4b.jpg";